import React from 'react';
import { Typography } from '@scale/scaleui';
import { MultiTurnInteractionConfiguration } from '@scale/shared/types/chat';
import InitialMessagesBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/InitialMessagesBuilder';
import { ChatDocumentationLink } from '@scale/shared/chat/documentation';
import { typeBuilderMap } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemas';

interface PreloadPromptAndResponsesProps {
  value: MultiTurnInteractionConfiguration;
  onSubmit: (config: MultiTurnInteractionConfiguration) => void;
}

const PreloadPromptsAndResponses = ({ value, onSubmit }: PreloadPromptAndResponsesProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Typography.H3>Preload Prompts and Responses</Typography.H3>
      <Typography.Paragraph2 color="text-neutral-500">
        Load the conversation with predefined prompts and model responses. These initial messages
        will appear inside the steps that you have configured below. The initial Prompt message will
        be prefilled in the Prompt step, and the Responses will be added to Response Selector steps
        in addition to any existing model responses. See Preloaded Prompts/Responses documentation{' '}
        <a
          className="text-primary-500"
          target="_blank"
          rel="noopener noreferrer"
          href={ChatDocumentationLink.InitialMessages}
        >
          here.
        </a>
      </Typography.Paragraph2>
      <div className="space-y-2">
        <InitialMessagesBuilder
          typeBuilderMap={typeBuilderMap}
          initialMessages={value.initialMessages || []}
          setInitialMessages={initialMessages => onSubmit({ ...value, initialMessages })}
        />
      </div>
    </div>
  );
};

export default PreloadPromptsAndResponses;
